export const submitForm = form => {
  const btn = document.createElement('button');
  btn.type = 'submit';
  btn.style.display = 'none';
  form.appendChild(btn);
  btn.click();
  btn.remove();
};



// WEBPACK FOOTER //
// ./src/utils/submitForm.js